import React from "react";
import { Link } from "react-router-dom";
import axios from "axios";
import { Pagination } from "react-bootstrap";
import { JWT_SECRET_TOKEN } from "../config";
import Cookie from "js-cookie";
const jwt = require("jsonwebtoken");
import { API_END_POINT } from "../config";
// import Swal from 'sweetalert2'
const token = Cookie.get("waffle_world_access_token");

import HasRole from "../hoc/HasRole";

export default class Categories extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      categories: [],
      activePage: 1,
      pages: 1,
      q: "",
      pageSize: 10,
      responseMessage: "Loading Categories...",
      token: localStorage.getItem("token"),
    };
  }

  componentWillMount() {
    this.fetchCategories();
  }

  fetchCategories = () => {
    axios.get(`${API_END_POINT}/api/categories`).then((response) => {
      let SortedArray = response.data.objects;
      SortedArray.sort((a, b) => new Date(b.date) - new Date(a.date));
      this.setState({
        categories: SortedArray,
        responseMessage: "No Categories Found...",
      });
    });
  };

  getParams() {
    const { activePage, pageSize } = this.state;
    return {
      params: {
        pageNumber: activePage,
        pageSize,
      },
    };
  }

  deleteCategory(categoryId, index) {
    const requestParams = {
      categoryId: categoryId,
    };
    if (confirm("Sind Sie sicher das sie die Kategorie löschen wollen?")) {
      const tokenx = jwt.sign({ payload: requestParams }, JWT_SECRET_TOKEN, {
        expiresIn: "1h",
      });
      axios
        .delete(`${API_END_POINT}/api/categories/delete`, {
          data: requestParams,
          headers: { "auth-token": tokenx },
        })
        .then((response) => {
          if (response.status === 200) {
            window.alert("Category Deleted Successfully");
            const categories = this.state.categories.slice();
            categories.splice(index, 1);
            this.setState({ categories });
          }
        });
    }
  }

  handleSelect(page) {
    this.setState({ activePage: page }, () => {
      axios
        .get(`${API_END_POINT}/api/fetch/locations-fetch`, this.getParams())
        // axios.get(`https://api.saaditrips.com/api/fetch/locations-fetch`, this.getParams())
        .then((response) => {
          this.setState({
            categories: response.data.items,
            activePage: page,
          });
        });
    });
  }

  handleSearch() {
    const { q } = this.state;
    if (q.length) {
      this.setState({
        loading: true,
        categories: [],
        responseMessage: "Loading Categories...",
      });
      // if(q === "") {
      //   this.fetchCategories();
      // } else {
      axios
        .get(`${API_END_POINT}/api/categories/search`, {
          params: { searchWord: this.state.q },
          headers: { "auth-token": token },
        })
        .then((response) => {
          let SortedArray = response.data.searchedItems;
          SortedArray.sort((a, b) => new Date(b.date) - new Date(a.date));
          this.setState({
            categories: SortedArray,
            loading: false,
            responseMessage: "No Categories Found...",
          });
        });
    }
  }

  render() {
    return (
      <div className="row animated fadeIn">
        <div className="col-12">
          <div className="row space-1">
            <div className="col-sm-4">
              <h3>Liste der Kategorien</h3>
            </div>
            <div className="col-sm-4">
              <div className="input-group">
                <input
                  className="form-control"
                  type="text"
                  name="search"
                  placeholder="Enter keyword"
                  value={this.state.q}
                  // onChange={(event) => this.setState({q: event.target.value})}
                  onChange={(event) =>
                    this.setState({ q: event.target.value }, () => {
                      if (this.state.q === "") {
                        this.fetchCategories();
                      }
                    })
                  }
                  onKeyPress={(event) => {
                    if (event.key === "Enter") {
                      this.handleSearch();
                    }
                  }}
                />
                <span className="input-group-btn">
                  <button
                    type="button"
                    onClick={() => this.handleSearch()}
                    className="btn btn-info search-btn"
                  >
                    Suchen
                  </button>
                </span>
              </div>
            </div>
            {/* <div className="col-sm-4 pull-right mobile-space">
              <HasRole requiredRole={['admin', 'data-entry']} requiredDepartment={['admin', 'sales']}>
                <Link to="/area_form">
                  <button type="button" className="btn btn-success marginTop">Add new Categories</button>
                </Link>
              </HasRole>
            </div> */}

            <div className="col-sm-4 pull-right mobile-space">
              <Link to="/categories/category_form">
                <button type="button" className="btn btn-success">
                  Neue Kategorien hinzufügen
                </button>
              </Link>
            </div>
          </div>
          <div className="table-responsive">
            <table className="table table-striped">
              <thead>
                <tr>
                  <th>Artikel Nummer.#</th>
                  <th>Bilder</th>
                  <th>Name</th>
                  <th>Beschreibung</th>
                  {/* <th>Marla-Size(Sqft)</th>
                  <th>Population</th>
                  <th>Latitude</th>
                  <th>Longitude</th> */}
                </tr>
              </thead>
              <tbody>
                {this.state.categories && this.state.categories.length >= 1 ? (
                  this.state.categories.map((category, index) => (
                    <tr key={index}>
                      <td>{index + 1}</td>
                      <td>
                        {
                          <img
                            style={{ height: "50px", width: "50px" }}
                            src={category.image && category.image}
                          />
                        }
                      </td>
                      <td>{category.name}</td>
                      {/* <td>{category.size}</td> */}
                      <td>{category.description}</td>
                      {/* <td>{category.marla_size}</td>
                    <td>{category.population}</td>
                    <td>{category.lat}</td>
                    <td>{category.lon}</td> */}
                      <td>
                        <Link to={`/categories/category/${category._id}`}>
                          <button type="button" className="btn btn-info btn-sm">
                            Artikel in Kategorie anzeigen
                          </button>
                        </Link>
                      </td>
                      {/* <HasRole requiredRole={['admin']} requiredDepartment={['admin', 'sales']}> */}
                      <td>
                        <Link to={`/categories/edit-category/${category._id}`}>
                          <span
                            className="fa fa-edit"
                            aria-hidden="true"
                          ></span>
                        </Link>
                      </td>
                      <td>
                        <span
                          className="fa fa-trash"
                          aria-hidden="true"
                          style={{ cursor: "pointer" }}
                          onClick={() =>
                            this.deleteCategory(category._id, index)
                          }
                        ></span>
                      </td>
                      {/* </HasRole> */}
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan="15" className="text-center">
                      {this.state.responseMessage}
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
          {/* <div className="text-center">
            <Pagination prev next items={this.state.pages} activePage={this.state.activePage} onSelect={this.handleSelect.bind(this)}> </Pagination>
          </div> */}
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/containers/Categories.jsx